// 科目dlg组件

const subjectBudgeDlg = {
  namespaced: true,

  state: {
    dlgBudgeShow: false,

    subjectBudgeId: '',

    subjectBudgeName: '',

    subjectBudgeType: '',

    dlgBudgeType: ''
  },

  getters: {
    dlgBudgeShow: state => state.dlgBudgeShow,

    subjectBudgeId: state => state.subjectBudgeId,

    subjectBudgeName: state => state.subjectBudgeName,

    subjectBudgeType: state => state.subjectBudgeType,

    dlgBudgeType: state => state.dlgBudgeType
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgBudgeShow = val
    },

    SET_SUBJECTID: (state, val) => {
      state.subjectBudgeId = val
    },

    SET_SUBJECTNAME: (state, val) => {
      state.subjectBudgeName = val
    },

    SET_SUBJECTTYPE: (state, val) => {
      state.subjectBudgeType = val
    },

    SET_DLGTYPE: (state, val) => {
      state.dlgBudgeType = val
    },
  },

  actions: {

  }
}

export default subjectBudgeDlg
